import { createContext } from "react";

export const TeacherContext = createContext()